import { render, staticRenderFns } from "./ConnectionError.vue?vue&type=template&id=8be6266a&"
import script from "./ConnectionError.vue?vue&type=script&lang=js&"
export * from "./ConnectionError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports